import * as Constants from "./constants";
import { getLookups, t, getIndustryTitle } from "./content";

/**
 * Checks if object is empty
 * @param obj
 * @returns {boolean}
 */
export function isEmptyObject(obj){
    return JSON.stringify(obj) === '{}';
};

/**
 * Convert image with URL to image Data
 * @param url
 * @param callback
 */
export function toDataUrl(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function() {
        let reader = new FileReader();
        reader.onloadend = function() {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
};

/**
 *
 * @param temp
 * @param mandatory
 * @returns {boolean}
 */
export function hasEmptyProperty(temp, mandatory) {
    for (var key in temp) {
        if (temp.hasOwnProperty(key))
            if (temp[key]?.length === 0){
                if(mandatory && mandatory.length > 0){
                    if(mandatory.includes(key))
                        return key;
                }else{
                    return false
                }
            }
    }
    return false
};

export function getIndustryId(industries, industry_name) {
    for(var i = 0; i < industries.length; i++) {
        if(industries[i].title.toLowerCase() === industry_name.toLowerCase()) {
            return industries[i].id.toString();
        }
    }
};

// Sort high to low
export const order = (elem1, elem2) => {
    return elem1 > elem2 ? -1 : (elem1 < elem2 ? 1 : 0);
}

export const scroll = () => {
    document.getElementById("top").scrollIntoView({ behavior: 'smooth' }, true);
}

export const transformIndustryData = (industryData) => {
    if (industryData) {
        return {
            id: industryData.id,
            name: industryData.name || industryData.title,
            title: getIndustryTitle(industryData),
        };
    }
    return "";
}

export function findIndustryBySelectValue(industries, value) {
    return (industries || []).find(
        (industry) => String(industry.id) === String(value) || industry.title === value
    );
}

export function findProfileBySelectValue(profiles, value) {
    return (profiles || []).find(
        (profile) => String(profile.id) === String(value) || profile.title === value || profile.name === value
    );
}

export const currentUserRole = () =>{
    return parseInt(localStorage.getItem(Constants.LOCAL_STORAGE_KEY_USER_ROLE_ID))
}

/**
 * Demo accounts are flagged with write_access = false on the corporate user.
 * Sessions that logged in before the flag existed have no value, so treat it as allowed.
 * This is a UI hint only, the API re-checks the flag in the database on every write.
 */
export const currentUserWriteAccess = () => {
    const authenticationData = JSON.parse(localStorage.getItem(Constants.MAZHR_JWT_KEY));
    return authenticationData?.write_access !== false;
}

export const storeUserWriteAccess = (writeAccess) => {
    const authenticationData = JSON.parse(localStorage.getItem(Constants.MAZHR_JWT_KEY));
    if (authenticationData) {
        localStorage.setItem(
            Constants.MAZHR_JWT_KEY,
            JSON.stringify({...authenticationData, write_access: writeAccess})
        );
    }
}

export const getAONAssessmentLabelById = (inst_id, locale) => {
    return getLookups(locale).assessments[String(inst_id)]?.name || null;
}

export const calculateAverageCeiling = (traits) => {
    const sum = traits.reduce((acc, val) => acc + val, 0);
    const average = sum / traits.length;
    return Math.ceil(average);
};

/*
 * Validates fields based on provided rules.
 * @param type {string} - The type of field to validate (e.g., 'text', 'email', 'item', 'list').
 * @param value {any} - The value of the field to validate.
 * @param customErrorMessage {string} - Optional custom error message to return if validation fails.
 * @returns {Object} - An object containing `isValid` (boolean) and `errorMessage` (string|null).
 * Example:
console.log(validateField("text", ""));     // { isValid: false, errorMessage: "This field is required." }
console.log(validateField("email", "wrong@email@"));     // { isValid: false, errorMessage: "Please enter a valid email address." }
console.log(validateField("list", []));    // { isValid: false, errorMessage: "Please provide at least one item." }
console.log(validateField("number", "abc"));    // { isValid: false, errorMessage: "Please enter a valid number." }
console.log(validateField("text", "Frontend Team")); // { isValid: true, errorMessage: null }
 */
const VALID_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateField(type, value, customErrorMessage) {
  const defaultMessages = {
    text: t("validation.fieldRequired"),
    email: t("validation.validEmail"),
    number: t("validation.validNumber"),
    list: t("validation.atLeastOneItem"),
    item: t("validation.selectValidOption"),
  };

  const isEmpty =
    value === undefined ||
    value === null ||
    value === "" ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0);

  const errorMessage =
    isEmpty
      ? customErrorMessage || defaultMessages[type] || t("validation.fieldRequired")
      : (type === "email" && !VALID_EMAIL_REGEX.test(value))
        ? customErrorMessage || defaultMessages.email
        : (type === "number" && isNaN(value))
          ? customErrorMessage || defaultMessages.number
          : null;

  return {
    isValid: !errorMessage,
    errorMessage
  };
}

export const convertLabelsToArrayOfWords = (labels) => {
    const MAX_WORDS_PER_LABEL = 1;
    return labels.map((label) => {
        if (typeof label == "string"){
            const words = label.split(' ');

            if (words.length <= MAX_WORDS_PER_LABEL) {
                return [label];
            }

            return words;
        }else{
            return label
        }
    });
}

export const processRoleInvitation = (userRole, roleList) => {
    // Owner role cannot be invited
    // HR Manager and HR Specialist roles are not available for now. TODO: Include them when they are added back
    let processedRoleList = roleList.filter(r => ![Constants.USER_ROLE_OWNER, Constants.USER_ROLE_SPECIALIST].includes(r.id));
    if (Constants.ADMINISTRATIVE_USER_ROLES.includes(userRole)) { // Owner and Admin can invite all roles except Owner
        return processedRoleList;
    } else if (userRole === Constants.USER_ROLE_HRD) { // HRD can invite all operational roles except HRD themselves
        return processedRoleList.filter(r => ![...Constants.ADMINISTRATIVE_USER_ROLES, Constants.USER_ROLE_HRD].includes(r.id));
    } else { // Other roles cannot invite users
        return [];
    }
}